module.exports = __webpack_public_path__ + "img/gears.66c14524.svg";